'use client'

import Calculator, { type CalculatorFormData } from '@/app/Calculator'

type VeteranCalculatorProps = {
  initialValues?: Partial<CalculatorFormData>
}

export default function VeteranCalculator({ initialValues }: VeteranCalculatorProps) {
  return <Calculator mode="veteran" initialValues={initialValues} />
}
